import axios from 'axios'
import { envConfig } from '../../env-config'

const ccsAPI = axios.create({
  baseURL: envConfig.ccsAPIUrl,
})

export async function getLeadInfoByCallId(callId) {
  const response = await ccsAPI.get(`calls/lead/${callId}`)

  return response.data
}

export async function getCallingNumbers(agentId) {
  const response = await ccsAPI.get(`calling_numbers/agent/${agentId}`)

  return response.data
}

export async function changeCallingNumber(agentId, displayNumber) {
  const response = await ccsAPI.post('calling_numbers/agent/changeDisplayNumber/', { agentId, displayNumber })

  return response.data
}

export async function editLeadStatus(leadInfo) {
  const response = await ccsAPI.post('calls/status', leadInfo)

  return response.data
}

export async function getMaintenanceStatus() {
  const response = await ccsAPI.get('/maintenance?client=AGENT')

  return response.data
}

export default ccsAPI
